<div class="relative mt-[50px] py-4 rounded-md">
    <div class="opacity-65 absolute w-full h-full top-0 left-0"></div>
    <div class="grid md:grid-cols-2 z-10">
        <div class="flex sm:text-left text-center">
            <div class="text-base leading-7 mt-10  lg:max-w-lg  z-10">
                <h2 class="font-bold tracking-tight sm:text-xl text-normal">
                    {{componentModel.title.value}}
                </h2>
                <h2 class="font-bold tracking-tight sm:text-4xl mt-10 text-light" >
                    {{componentModel.subtitle.value}}
                </h2>
                <div class="max-w-lg mt-10">
                  <span class="leading-10 font-medium text-xl text-light" >
                    {{componentModel.description.value}}
                  </span>
                </div>
                @if(componentModel.buttonText.value){
                    <div class="mt-10">
                        <white-label-button  type="primary"
                                             [text]="componentModel.buttonText.value"
                                             [link]="componentModel.buttonLink.value"></white-label-button>
                    </div>
                }
            </div>
        </div>
        <div class="md:flex hidden align-center md:justify-end justify-center">
            <div class="w-[90%] h-[370px] overflow-hidden text-base leading-7 mt-6 relative rounded-md" >
                @if(componentModel.videoUrl.value){
                    @defer {
                        <white-label-video-player [videoUrl]="componentModel.videoUrl.value" [showPlayButton]="true">
                        </white-label-video-player>
                    } @placeholder{
                        <div></div>
                    }

                } @else if (componentModel.imageUrl.value){
                    <img loading="lazy"  [src]="componentModel.imageUrl.value" class="soviet-effect w-full h-full" [alt]="componentModel.title.value">
                }
                <div class="border-2 rounded-2xl border-white w-[90%] h-[90%] absolute top-[5%] left-[5%] hidden border-primary radius-md"></div>
            </div>
        </div>
    </div>

</div>
